export enum PracticeType {
  REGULAR = 'REGULAR',
  SELF_ENROLL = 'SELF_ENROLL',
  PRIVATE = 'PRIVATE',
}
